import Aos from "./aos";

const StatsBlock = ($) => {
	const statsBlock = $("#js-stats-block")[0];

	if (statsBlock) {
		Aos();
	}
};

export default StatsBlock;
